export const homeTokens = {
  containerMax: 'lg',
  sectionPy: { xs: 8, md: 10 },
  sectionGap: { xs: 4, md: 6 },
  heading: {
    section: {
      fontSize: { xs: '1.95rem', md: '2.5rem' },
      fontWeight: 800,
      letterSpacing: '-0.02em',
      lineHeight: 1.15
    },
    bodyLead: {
      fontSize: { xs: '1rem', md: '1.1rem' },
      lineHeight: 1.7,
      color: 'text.secondary'
    }
  },
  card: {
    radius: 3,
    border: '1px solid rgba(15, 23, 42, 0.08)',
    shadow: '0 12px 28px rgba(15, 23, 42, 0.08)',
    hoverShadow: '0 18px 34px rgba(15, 23, 42, 0.12)'
  },
  icon: {
    large: 36,
    medium: 24
  },
  button: {
    radius: '12px'
  }
};
